import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  MODELO_FATURAMENTO_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    MODELO_FATURAMENTO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_FATURAMENTO_ENDPOINT,
    id,
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [MODELO_FATURAMENTO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [MODELO_FATURAMENTO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_FATURAMENTO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_FATURAMENTO_ENDPOINT],
    id
  );
}
